import { observable } from 'mobx'

export default class BooksStore {
  @observable books = []
  @observable book = []
  @observable created = false

  updateBooks(data) {
    this.books = data
  }

  updateBook(data) {
    this.book = data
  }

  updateCreated() {
    this.created = true
  }

  updateSessionDataById(id) {
    var index = this.books
      .map(x => {
        return x.id
      })
      .indexOf(id)

    this.book = this.books[index]
  }

  updateDataBySession() {
    var index = this.books
      .map(x => {
        return x.id
      })
      .indexOf(this.book.id)
    this.books[index] = this.book
  }

  deleteSessionById(id) {
    var index = this.books
      .map(x => {
        return x.id
      })
      .indexOf(id)
    this.books.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./src/stores/BooksStore.js